import {
    Box,
    Button,
    Divider,
    FormControl,
    FormLabel,
    Input,
    Radio,
    RadioGroup,
    Stack,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    Table,
    Tbody,
    Td,
    Text,
    Th,
    Thead,
    Tr,
    useToast,
    Select,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

interface Operator {
    name: string;
    ref_id: string;
}

const banks = ["Standard Bank", "FNB", "ABSA", "Nedbank", "Capitec"];

const cardsBorderRadii ="8px";

const FlightCheckout = () => {
    const navigate = useNavigate();
    const toast = useToast();

    const [selectedMethod, setSelectedMethod] = useState("card");
    const [bank, setBank] = useState(banks[0]);
    const [operators, setOperators] = useState<Operator[]>([]);
    const [selectedOperator, setSelectedOperator] = useState<string>("");

    const [formData, setFormData] = useState({
        cardNumber: "",
        cardHolder: "",
        expiryDate: "",
        cvv: "",
        airtelNumber: "",
        eftReference: "",
        mobile: "",
        amount: "",
        charge_id: "",
        email: "",
        first_name: "",
        last_name: "",
    });

    const [departureFlight, setDepartureFlight] = useState<any>(null);
    const [returnFlight, setReturnFlight] = useState<any>(null);
    const [totalPrice, setTotalPrice] = useState("0.00");

    useEffect(() => {
        const round = sessionStorage.getItem("selectedFlightRoundTrip");
        const oneWay = sessionStorage.getItem("selectedFlight");

        if (round) {
            const { departure, return: ret, total } = JSON.parse(round);
            setDepartureFlight(departure);
            setReturnFlight(ret);
            setTotalPrice(total);
        } else if (oneWay) {
            const flight = JSON.parse(oneWay);
            setDepartureFlight(flight);
            setTotalPrice(flight.price?.grandTotal || "0.00");
        }
    }, []);

    useEffect(() => {
        axios.get("http://localhost:5000/mobile-money").then((res) => {
            setOperators(res.data.data);
            console.log('oparators', res.data.data);
            if (res.data.length > 0) setSelectedOperator(res.data[0].ref_id);
        });
    }, []);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    };

    const submitPayment = () => {
        toast({
            title: "Payment Submitted",
            description: `Payment method: ${selectedMethod}`,
            status: "success",
            duration: 3000,
        });
        navigate("/success");
    };

    const renderFlightRow = (flight: any, label: string) => {
        const segment = flight?.itineraries?.[0]?.segments?.[0];
        const last = flight?.itineraries?.[0]?.segments?.at(-1);
        return (
            <Tr>
                <Td fontWeight="bold">{label}</Td>
                <Td>
                    {segment?.departure?.iataCode} → {last?.arrival?.iataCode}
                </Td>
                <Td>{segment?.departure?.at}</Td>
                <Td>{segment?.arrival?.at}</Td>
                <Td>
                    {flight?.price?.grandTotal} {flight?.price?.currency}
                </Td>
            </Tr>
        );
    };

    return (
        <Box maxW="3xl" mx="auto" p={6} borderWidth="1px" borderRadius={cardsBorderRadii}>
            <Text fontSize="2xl" fontWeight="bold" mb={4}>
                Flight Checkout
            </Text>

            <Table variant="striped" size="sm" mb={6}>
                <Thead>
                    <Tr>
                        <Th>Trip</Th>
                        <Th>Route</Th>
                        <Th>Departure</Th>
                        <Th>Arrival</Th>
                        <Th>Price</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {departureFlight && renderFlightRow(departureFlight, "Departure")}
                    {returnFlight && renderFlightRow(returnFlight, "Return")}
                </Tbody>
            </Table>

            <Text mb={3} fontWeight="bold">
                Total: {totalPrice} {departureFlight?.price?.currency}
            </Text>

            <Tabs
                onChange={(index) =>
                    setSelectedMethod(["card", "eft", "mobile", "cash"][index])
                }
            >
                <TabList>
                    <Tab>Credit/Debit</Tab>
                    <Tab>EFT</Tab>
                    <Tab>Mobile Money</Tab>
                    <Tab>Pay at Airport</Tab>
                </TabList>

                <TabPanels>
                    <TabPanel>
                        <Stack spacing={4}>
                            <FormControl isRequired>
                                <FormLabel>Card Number</FormLabel>
                                <Input
                                    name="cardNumber"
                                    value={formData.cardNumber}
                                    onChange={handleChange}
                                />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel>Card Holder</FormLabel>
                                <Input
                                    name="cardHolder"
                                    value={formData.cardHolder}
                                    onChange={handleChange}
                                />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel>Expiry Date</FormLabel>
                                <Input
                                    name="expiryDate"
                                    value={formData.expiryDate}
                                    onChange={handleChange}
                                />
                            </FormControl>
                            <FormControl isRequired>
                                <FormLabel>CVV</FormLabel>
                                <Input name="cvv" value={formData.cvv} onChange={handleChange} />
                            </FormControl>
                        </Stack>
                    </TabPanel>

                    <TabPanel>
                        <FormControl>
                            <FormLabel>Select Bank</FormLabel>
                            <RadioGroup value={bank} onChange={setBank}>
                                <Stack direction="column">
                                    {banks.map((b) => (
                                        <Radio key={b} value={b}>
                                            {b}
                                        </Radio>
                                    ))}
                                </Stack>
                            </RadioGroup>
                        </FormControl>
                        <FormControl mt={4}>
                            <FormLabel>Payment Reference</FormLabel>
                            <Input
                                placeholder="e.g. FLT123456"
                                name="eftReference"
                                value={formData.eftReference}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </TabPanel>

                    <TabPanel>
                        <FormControl isRequired>
                            <FormLabel>Mobile Number</FormLabel>
                            <Input
                                placeholder="e.g. +265 99xxxxxxx"
                                name="mobile"
                                value={formData.mobile}
                                onChange={handleChange}
                            />
                        </FormControl>
                        <FormControl isRequired mt={4}>
                            <FormLabel>Operator</FormLabel>
                            <Select
                                value={selectedOperator}
                                onChange={(e) => setSelectedOperator(e.target.value)}
                            >
                                {operators.map((op) => (
                                    <option key={op.ref_id} value={op.ref_id}>
                                        {op.name}
                                    </option>
                                ))}
                            </Select>
                        </FormControl>
                        <FormControl isRequired mt={4}>
                            <FormLabel>Amount</FormLabel>
                            <Input
                                name="amount"
                                value={formData.amount}
                                onChange={handleChange}
                            />
                        </FormControl>
                        <FormControl isRequired mt={4}>
                            <FormLabel>Charge ID</FormLabel>
                            <Input
                                name="charge_id"
                                value={formData.charge_id}
                                onChange={handleChange}
                            />
                        </FormControl>
                        <FormControl mt={4}>
                            <FormLabel>Email</FormLabel>
                            <Input
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                            />
                        </FormControl>
                        <FormControl mt={4}>
                            <FormLabel>First Name</FormLabel>
                            <Input
                                name="first_name"
                                value={formData.first_name}
                                onChange={handleChange}
                            />
                        </FormControl>
                        <FormControl mt={4}>
                            <FormLabel>Last Name</FormLabel>
                            <Input
                                name="last_name"
                                value={formData.last_name}
                                onChange={handleChange}
                            />
                        </FormControl>
                    </TabPanel>

                    <TabPanel>
                        <Text>You'll pay at the airport counter. No details needed now.</Text>
                    </TabPanel>
                </TabPanels>
            </Tabs>

            <Divider my={6} />

            <Button colorScheme="blue" size="lg" w="100%" onClick={submitPayment}>
                Confirm Booking & Pay
            </Button>
        </Box>
    );
};

export default FlightCheckout;
